/* This file is autogenerated, see readme.md for instructions */
import AnalyticsSvgIcon from '@bloomreach/banana-theme/icons/analytics.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const AnalyticsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <AnalyticsSvgIcon />
    </Icon>
  );
});

AnalyticsIcon.displayName = 'AnalyticsIcon';

export default AnalyticsIcon;
